export const visitLink = ({ url }: { url: string }) => {
  const link: HTMLAnchorElement = document.createElement("a");
  link.style.display = "none";
  link.target = "_blank";
  link.href = url;
  link.click();
  link.remove();
};

export const navigateLink = (url: string) => {
  window.location.href = url;
};
